import { render, staticRenderFns } from "./full-container.vue?vue&type=template&id=1889fb09&scoped=true&"
import script from "./full-container.vue?vue&type=script&lang=js&"
export * from "./full-container.vue?vue&type=script&lang=js&"
import style0 from "./full-container.vue?vue&type=style&index=0&id=1889fb09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1889fb09",
  null
  
)

export default component.exports